// 路由
export default {
    // mainMenu
    t_order: "订单",
    t_product: "商品",
    t_user: "用户",
    // order
    order: "订单管理",
    order_single_list: "项目订单列表",
    order_private_list: "包场订单列表",
    order_product_list: "商品订单列表",
    order_recharge_list: "充值订单列表",
    refund: "退款处理",
    consumption: "场次核销",

    // product
    product: "商品管理",
    product_list: "商品列表",
    product_edit: "创建商品",
    product_category: "商品分类",
    product_brand: "商品品牌",
    product_attribute: "商品属性",

    // user
    user: "用户列表",
    membercard: "会员卡"
};
